import React, { useState, useEffect } from 'react'
import {
    getcampaignsByAggregatorIdbyName,
    downloadCampaignsByAggregatorId,
    getLeadsByCampaignId,
    downloadLeadsByCampaignId
} from '../../ActionCreator';
import Loader from '../../../../../presentationals/Loader/Loader.component'
import moment from 'moment'

// ── Inline Styles for Modal Popup ───────────────────────────────────────────
const overlayStyle = {
    position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.45)',
    display: 'flex', alignItems: 'center', justifyItems: 'center',
    justifyContent: 'center', zIndex: 9999,
}
const modalStyle = {
    background: '#fff', borderRadius: '12px', width: '850px', maxWidth: '95vw',
    maxHeight: '85vh', display: 'flex', flexDirection: 'column',
    boxShadow: '0 20px 60px rgba(0,0,0,0.2)', overflow: 'hidden',
}
const modalHeaderStyle = {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '16px 20px', borderBottom: '1px solid #e5e7eb', flexShrink: 0,
}
const modalBodyStyle = { overflowY: 'auto', padding: '20px', flex: 1 }
const modalFooterStyle = {
    display: 'flex', justifyContent: 'flex-end', gap: '10px',
    padding: '12px 20px', borderTop: '1px solid #e5e7eb', flexShrink: 0, background: '#fff',
}
const closeBtnStyle = {
    border: 'none', background: '#f3f4f6', borderRadius: '6px',
    width: '32px', height: '32px', cursor: 'pointer', fontSize: '18px',
    color: '#6b7280', display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: 1,
}
const downloadBtnStyle = {
    border: 'none', background: '#4F46E5', color: '#fff',
    borderRadius: '6px', padding: '6px 14px', fontSize: '13px',
    fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px',
}
const viewBtnStyle = {
    border: 'none', background: '#EEF2FF', color: '#4F46E5',
    borderRadius: '6px', padding: '5px 12px', fontSize: '12px',
    fontWeight: 600, cursor: 'pointer', display: 'inline-flex', alignItems: 'center',
}

// ── Leads List Modal Component ──────────────────────────────────────────────
function LeadsModal({ campaignId, sDate, eDate, aggregatorId, onClose }) {
    const [leads, setLeads] = useState([])
    const [loading, setLoading] = useState(false)
    const [downloading, setDownloading] = useState(false)

    useEffect(() => {
        setLoading(true)
        getLeadsByCampaignId(sDate, eDate, aggregatorId, campaignId, (response) => {
            setLoading(false)
            setLeads(Array.isArray(response) ? response : (response?.data ?? []))
        })
    }, [campaignId, sDate, eDate, aggregatorId])

    const handleDownloadLeads = () => {
        setDownloading(true)
        downloadLeadsByCampaignId(sDate, eDate, aggregatorId, campaignId, () => {
            setDownloading(false)
        })
    }

    // Dynamic Columns based on lead fields
    const keys = leads.length > 0 ? Object.keys(leads[0]) : []
    const toLabel = (k) => k.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase())

    return (
        <div style={overlayStyle} onClick={onClose}>
            {(loading || downloading) && <Loader />}
            <div style={modalStyle} onClick={e => e.stopPropagation()}>
                {/* Header */}
                <div style={modalHeaderStyle}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: '#111827' }}>
                            Leads for Campaign: {campaignId}
                        </h3>
                        {leads.length > 0 && (
                            <span style={{ background: '#EEF2FF', color: '#4F46E5', fontSize: '12px', fontWeight: 600, borderRadius: '20px', padding: '2px 10px' }}>
                                {leads.length} records
                            </span>
                        )}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {leads.length > 0 && (
                            <button style={downloadBtnStyle} onClick={handleDownloadLeads} disabled={downloading}>
                                <svg style={{width:'auto'}} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
                                </svg>
                                {downloading ? 'Downloading…' : 'Download Leads'}
                            </button>
                        )}
                        <button style={closeBtnStyle} onClick={onClose}>×</button>
                    </div>
                </div>

                {/* Body */}
                <div style={modalBodyStyle}>
                    {loading ? (
                        <p style={{ textAlign: 'center', color: '#6b7280', padding: '48px 0' }}>Loading leads…</p>
                    ) : leads.length === 0 ? (
                        <p style={{ textAlign: 'center', color: '#6b7280', padding: '48px 0' }}>No leads found for this campaign.</p>
                    ) : (
                        <div className="main-customized-table" style={{ maxHeight: '55vh', overflowY: 'auto' }}>
                            <table className="table" style={{ fontSize: '13px' }}>
                                <thead>
                                    <tr style={{ background: '#f9fafb', position: 'sticky', top: 0, zIndex: 1 }}>
                                        <th>#</th>
                                        {keys.map(col => <th key={col}>{toLabel(col)}</th>)}
                                    </tr>
                                </thead>
                                <tbody>
                                    {leads.map((row, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            {keys.map(col => (
                                                <td key={col}>{String(row[col] ?? '—')}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>

                {/* Footer */}
                <div style={modalFooterStyle}>
                    <button style={{ border: '1px solid #d1d5db', background: '#fff', color: '#374151', borderRadius: '8px', padding: '8px 22px', fontSize: '13px', fontWeight: 600, cursor: 'pointer' }} onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    )
}

// ── Main Component ──────────────────────────────────────────────────────────
export default function Campaign({ handleCustomTab, Data, dateFilterPopup, commonFilter, setDateFilterPopup }) {
    const [loader, setLoader] = useState(false)
    const [tableData, settableData] = useState([])
    const [campaignDownloadInProgress, setCampaignDownloadInProgress] = useState(false)
    const [selectedCampaignId, setSelectedCampaignId] = useState(null) // Holds campaignId for leads popup

    useEffect(() => {
        if (
            commonFilter?.fromDate !== dateFilterPopup.from ||
            commonFilter?.toDate !== dateFilterPopup.to
        ) {
            setDateFilterPopup((prev) => ({
                ...prev,
                from: commonFilter.fromDate,
                to: commonFilter.toDate
            }));
        }
        const obj = { start: moment(commonFilter.fromDate).format("DD-MM-YYYY"), end: moment(commonFilter.toDate).format("DD-MM-YYYY") }
        ApiData(obj)
    }, [commonFilter])

    const ApiData = (obj) => {
        setLoader(true)
        getcampaignsByAggregatorIdbyName(obj?.start ?? "", obj?.end ?? "", Data?.id ?? "", callback => {
            setLoader(false)
            settableData(callback?.data ?? [])
        })
    }

    const handleDownloadCampaigns = () => {
        const start = moment(commonFilter?.fromDate).format("DD-MM-YYYY")
        const end = moment(commonFilter?.toDate).format("DD-MM-YYYY")
        setCampaignDownloadInProgress(true)
        setLoader(true)
        downloadCampaignsByAggregatorId(start, end, Data?.id ?? "", () => {
            setCampaignDownloadInProgress(false)
            setLoader(false)
        })
    }

    const start = moment(commonFilter?.fromDate).format("DD-MM-YYYY")
    const end = moment(commonFilter?.toDate).format("DD-MM-YYYY")

    return (
        <>
            {loader ? <Loader /> : ""}

            {/* Leads Modal Popup */}
            {selectedCampaignId && (
                <LeadsModal
                    campaignId={selectedCampaignId}
                    sDate={start}
                    eDate={end}
                    aggregatorId={Data?.id ?? ''}
                    onClose={() => setSelectedCampaignId(null)}
                />
            )}

            <div className='OverView-Main-Section min-size-marketing-1800'>
                <div className="row">
                    <div className="col-xs-12">
                        <div className="customDash-table" style={{ marginTop: '30px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                <h5 style={{ margin: 0 }}>Campaign's List</h5>
                                <button
                                    style={{...downloadBtnStyle, marginRight:"5px"}}
                                    onClick={handleDownloadCampaigns}
                                    disabled={campaignDownloadInProgress}
                                >
                                    <svg style={{width:'auto'}} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
                                    </svg>
                                    {campaignDownloadInProgress ? 'Downloading…' : 'Download Campaigns'}
                                </button>
                            </div>
                            <div className='main-customized-table'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th>Campaign Name</th>
                                            <th>Partner Name</th>
                                            <th>Start Date</th>
                                            <th>Leads</th>
                                            <th>Disbursement</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tableData?.length > 0 ? tableData?.map((val, id) => {
                                            return (
                                                <tr key={id}>
                                                    <td>{val?.campaignName ?? ""}</td>
                                                    <td>{val?.partnerName ?? ""}</td>
                                                    <td>{val?.startDate ?? ""}</td>
                                                    <td>{val?.totalLeads ?? ""}</td>
                                                    <td>{val?.disbursedLeads ?? ""}</td>
                                                    <td>{val?.status === true ? "Active" : "Inactive"}</td>
                                                    <td>
                                                        {val?.totalLeads && Number(val.totalLeads) > 0 ? (
                                                            <button
                                                                style={viewBtnStyle}
                                                                onClick={() => setSelectedCampaignId(val?.campaignId)}
                                                            >
                                                                View Leads
                                                            </button>
                                                        ) : (
                                                            "—"
                                                        )}
                                                    </td>
                                                </tr>
                                            )
                                        }) : (
                                            <tr>
                                                <td colSpan={7} style={{ textAlign: 'center', color: '#9ca3af', padding: '24px 0' }}>
                                                    No campaigns found.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
